



































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Campus, CampusesApi, PerformoSettings } from 'performo-api';
import { mapGetters } from 'vuex';
import { handleApiError } from '@/ApiHelpers';

@Component({
  computed: mapGetters({ settings: 'settings', campusesApi: 'campusesApi' })
})
export default class CampusPicker extends Vue {
  @Prop({ required: true, type: String })
  private propertyId!: string;

  @Prop({ required: true })
  private value!: string;

  @Prop({ required: false, default: false, type: Boolean })
  private hideLabel?: boolean;

  @Prop({ required: false, type: Boolean, default: false })
  private hideAll?: boolean;

  @Prop({ required: false, type: Boolean, default: false })
  private required?: boolean;

  @Prop({ required: false, type: String })
  private intendedValue?: string;

  private settings!: PerformoSettings;
  private campusesApi!: CampusesApi;
  private campuses: Campus[] = [];
  private loadingCampuses = false;

  get getValue() {
    return this.value;
  }

  private get campusLabel() {
    return this.settings.campusLabelSingular;
  }

  get sortedCampuses() {
    if (!this.campuses) {
      return null;
    }
    return this.campuses.sort((a, b) => {
      if (a.campusName && b.campusName) {
        return a.campusName.localeCompare(b.campusName);
      }
      return 0;
    });
  }

  @Watch('propertyId')
  private async propertyIdChanged() {
    this.$emit('input', '');
    await this.loadCampuses();
  }

  // make sure the component input is updated if intendedValue is used
  @Watch('intendedValue')
  private async intendedValueChanged() {
    this.$emit('input', this.intendedValue);
  }

  private async loadCampuses() {
    if (!this.propertyId) {
      return;
    }
    try {
      this.loadingCampuses = true;
      this.campuses = [];
      this.campuses = await this.campusesApi.queryCampuses({
        propertyId: this.propertyId
      });
      if (
        this.intendedValue &&
        this.campuses.filter((c) => c.campusName === this.intendedValue)
          .length === 1
      ) {
        this.$emit('input', this.intendedValue);
      }
    } catch (error) {
      handleApiError(error);
    } finally {
      this.loadingCampuses = false;
    }
  }

  private async mounted() {
    await this.loadCampuses();
  }
}
